export default new class Favorite {
    constructor() {
        this.favorite = '[data-favorite]';

        if (!$(this.favorite).length) return;

        this.favoriteDelete = '[data-favorite-delete]';
        this.favoriteItem = '[data-favorite-item-id]';
        this.headerFavoriteCounter = '[data-header-favorite-counter]';
        this.favoriteItemSale = '.category__list-item-sale';

        this.eventsHandler();
        this.calculateFavoriteItems();
        this.renderSale();
    }

    eventsHandler() {
        let $doc = $(document);

        $doc.on('click', this.favoriteDelete, (e) => {
            e.preventDefault();
            this.deleteItemFromFavorite($(e.currentTarget));
        })
    }

    deleteItemFromFavorite($btnDelete) {
        let itemId = $btnDelete.closest(this.favoriteItem).data('favorite-item-id');

        // MigrationHelper.reduceHeaderFavoriteCounter();
        $btnDelete.closest(this.favoriteItem).remove();
        this.sendData({id: itemId});
    }

    isAllItemsDeleted() {
        let $item = $(this.favoriteItem);

        if (!$item.length) {
            location.reload();
        }
    }

    sendData(data) {
        $.request('onRemoveFromFavorites', {
            data: {'id': data.id},
            complete: () => {
                this.isAllItemsDeleted();
            }
        })
    }

    calculateFavoriteItems() {
        let itemsCount = $(this.favoriteItem).length;

        $(this.headerFavoriteCounter).text(itemsCount);
    }

    renderSale() {
        const $saleItemList = $(this.favoriteItemSale);
        if ($saleItemList.length == 0) return;

        $saleItemList.each((i,item) => this.calculateAndSetSale(item))
    }

    calculateAndSetSale(item) {
        const oldPrice = $(item).data('old');
        const newPrice = $(item).data('new');
        const sale = Math.round((oldPrice - newPrice) / (oldPrice * 0.01))

        $(item).text(`${sale}%`);
    }
}
